export default [
  {
    label: 'Same Day',
    value: 'SameDay',
  },
  {
    label: 'One Day Before',
    value: 'DayBefore',
  },
  {
    label: 'One Week Before',
    value: 'OneWeekBefore',
  },
  {
    label: 'One Month Before',
    value: 'OneMonthBefore',
  },
];
